<template>
  <div v-if="emptySiteDetail">
    <br />
    <h3>Please select site id first...</h3>
    <ejs-button v-on:click.native="onBackButtonClick" cssClass="e-primary margin-button"
      >Back</ejs-button
    >
  </div>

  <div v-else>
    <div style="display: flex; justify-content: end">
      <ejs-button
        style="margin: 10px"
        type="Button"
        cssClass="e-success"
        v-on:click.native="onExportToExcel"
      >
        Export to Excel
      </ejs-button>
      <ejs-button v-on:click.native="onBackButtonClick" cssClass="e-info">Back</ejs-button>
    </div>

    <div>
      <fieldset>
        <legend><h3 class="site-details-title-color">Site Details</h3></legend>
        <div class="grid-container-site-details">
          <ejs-textbox
            float-label-type="Always"
            placeholder="Site #"
            readonly="true"
            :value="siteId"
          />
          <ejs-textbox
            float-label-type="Always"
            placeholder="Facility Status"
            readonly="true"
            v-model="currentSiteDetails.facility_Status"
          />
          <div style="grid-column: span 2">
            <ejs-textbox
              float-label-type="Always"
              placeholder="Site Name"
              readonly="true"
              v-model="currentSiteDetails.site_Name"
            />
          </div>
          <div style="grid-column: span 3">
            <ejs-textbox
              float-label-type="Always"
              placeholder="Site Address"
              readonly="true"
              v-model="currentSiteDetails.site_Address"
            />
          </div>
          <ejs-textbox
            float-label-type="Always"
            placeholder="Certificate OnHOLD (Due to Non-Compliance)"
            readonly="true"
            v-model="currentSiteDetails.hold_Certificates"
          />
          <ejs-textbox
            float-label-type="Always"
            placeholder="Facility Type"
            readonly="true"
            v-model="currentSiteDetails.facility_Type"
          />
          <ejs-textbox
            float-label-type="Always"
            placeholder="Owner #"
            readonly="true"
            v-model="currentSiteDetails.owner_Id"
          />
          <div style="grid-column: span 2">
            <ejs-textbox
              float-label-type="Always"
              placeholder="Owner Name"
              readonly="true"
              v-model="currentSiteDetails.owner_Name"
            />
          </div>
          <ejs-textbox
            float-label-type="Always"
            placeholder="Owner Contact"
            readonly="true"
            v-model="currentSiteDetails.owner_Contact"
          />
          <div style="grid-column: span 3">
            <ejs-textbox
              float-label-type="Always"
              placeholder="Owner Details"
              readonly="true"
              v-model="currentSiteDetails.owner_Detail"
            />
          </div>
          <div style="grid-column: span 3">
            <ejs-textbox
              float-label-type="Always"
              placeholder="Owner Address"
              readonly="true"
              v-model="currentSiteDetails.owner_Address"
            />
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>
          <h3 class="site-details-title-color">Contact Details</h3>
        </legend>
        <div class="grid-container-site-details">
          <!-- <ejs-textbox
            float-label-type="Always"
            placeholder="Number #"
            readonly="true"
            v-model="currentSiteDetails.contact_Number"
          /> -->
          <ejs-textbox
            float-label-type="Always"
            placeholder="Name"
            readonly="true"
            v-model="currentSiteDetails.owner_Contact"
          />
          <div style="grid-column: span 2">
            <ejs-textbox
              float-label-type="Always"
              placeholder="Details"
              readonly="true"
              v-model="currentSiteDetails.owner_Detail"
            />
          </div>
          <div style="grid-column: span 3">
            <ejs-textbox
              float-label-type="Always"
              placeholder="Address"
              readonly="true"
              v-model="currentSiteDetails.owner_Address"
            />
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>
          <h3 class="site-details-title-color">Location Information</h3>
        </legend>
        <div class="grid-container-site-details">
          <fieldset style="grid-column: span 2">
            <legend>
              <h5>Lot/Block/Plan</h5>
            </legend>
            <div class="grid-container-location-details">
              <ejs-textbox
                float-label-type="Always"
                placeholder="Lot"
                readonly="true"
                v-model="currentSiteDetails.lot"
              />
              <ejs-textbox
                float-label-type="Always"
                placeholder="Block"
                readonly="true"
                v-model="currentSiteDetails.block"
              />
              <ejs-textbox
                float-label-type="Always"
                placeholder="Plan"
                readonly="true"
                v-model="currentSiteDetails.plan"
              />
            </div>
          </fieldset>
          <fieldset style="grid-column: span 2">
            <legend>
              <h5>Address</h5>
            </legend>
            <div>
              <ejs-textbox
                float-label-type="Always"
                placeholder="Address"
                readonly="true"
                v-model="currentSiteDetails.address_Line_1"
              />
            </div>
          </fieldset>
        </div>
        <div class="gird-container-site-details">
          <fieldset>
            <legend>
              <h5>ATS Description (Standard)</h5>
            </legend>
            <div class="grid-container-location-details grid-template-col-6">
              <ejs-textbox
                float-label-type="Always"
                placeholder="LSD"
                readonly="true"
                v-model="currentSiteDetails.standard_LSD"
              />
              <ejs-textbox
                float-label-type="Always"
                placeholder="QTR"
                readonly="true"
                v-model="currentSiteDetails.standard_QTR"
              />
              <ejs-textbox
                float-label-type="Always"
                placeholder="SEC"
                readonly="true"
                v-model="currentSiteDetails.standard_SEC"
              />
              <ejs-textbox
                float-label-type="Always"
                placeholder="TWP"
                readonly="true"
                v-model="currentSiteDetails.common_TWP"
              />
              <ejs-textbox
                float-label-type="Always"
                placeholder="RGE"
                readonly="true"
                v-model="currentSiteDetails.common_REG"
              />
              <ejs-textbox
                float-label-type="Always"
                placeholder="MER"
                readonly="true"
                v-model="currentSiteDetails.common_MER"
              />
            </div>
          </fieldset>
        </div>
      </fieldset>
      <div style="margin-top: 5px" class="e-card">
        <div class="e-card-title">Tank Information</div>
        <div class="e-card-separator"></div>
        <div class="e-card-content">
          <ejs-grid
            :dataSource="currentSiteTanks"
            ref="refTankInfo"
            :created="created"
            :allowSorting="true"
            :allowPaging="true"
            :pageSettings="pageSettings"
            :toolbar="toolbarOptions"
            :allowTextWrap="true"
            height="100%"
            width="100%"
          >
            <e-columns>
              <e-column field="tank_Type" headerText="Tank Type" textAlign="Left" width="120" />
              <e-column
                field="tank_Serial_No"
                headerText="Tank Serial#"
                textAlign="Left"
                width="120"
              />
              <!-- <e-column
                field="tank_Id"
                headerText="Tank Id"
                textAlign="Left"
                width="120"
              /> -->
              <e-column field="split_Tank" headerText="Split Tank" textAlign="Left" width="120" />
              <e-column
                field="cust_Tank_No"
                headerText="Cust. Tank No."
                textAlign="Left"
                width="120"
              />
              <e-column field="tank_Status" headerText="Tank Status" textAlign="Left" width="120" />
              <e-column
                field="installation_Year_Month"
                headerText="Installation Year/Month"
                textAlign="Left"
                width="140"
              />
              <e-column
                field="tank_Material"
                headerText="Tank Material"
                textAlign="Left"
                width="120"
              />
              <e-column field="contents" headerText="Contents" textAlign="Left" width="120" />
              <e-column field="contents_Desc" headerText="Contents Desc" textAlign="Left" width="120" />
              <e-column
                field="tank_Construction_Spec"
                headerText="Tank Construction Spec"
                textAlign="Left"
                width="140"
              />
              <e-column
                field="specfiction_Description"
                headerText="Specification Description"
                textAlign="Left"
                width="140"
              />
            </e-columns>
          </ejs-grid>
        </div>
      </div>
      &nbsp;
      <div style="margin-top: 5px" class="e-card" v-if="isSiteReviewReadyData
        && isSiteReviewReadyData.editPermission
        && !this.currentSiteDetails.isInvoiced
        && this.currentSiteDetails.facility_Status === 'Active'">
        <div class="e-card-title">
          Comments
          <span class="sub-text">
            - Complete ONLY if submitting to ASCA Tanks for review and updates are required to your site(s)
          </span>
        </div>
        <div class="e-card-separator"></div>
        <div class="e-card-content">
          <ejs-textbox
            ref="siteComments"
            float-label-type="Always"
            placeholder="Comments: "
            :maxlength="250"
            @input="onInputChange"
            :multiline="true"
            :row="5"
            :created="onCommentsBoxCreation"
          />
        </div>
      </div>
      &nbsp;
      <div class="align-center-bottom">
        <ejs-button @click.native="onBackButtonClick" cssClass="e-primary margin-button"
          >Back</ejs-button
        >
        <ejs-button
          v-if="showReview && !this.currentSiteDetails.isInvoiced"
          @click.native="goToReview"
          style="margin: 10px"
          cssClass="e-info margin-button"
          >Review</ejs-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
} from "@syncfusion/ej2-vue-grids";
import { tokenStorage } from "@/shared/storage-service";
import appConfig from "@/app.config";
import { mapGetters } from "vuex";

Vue.use(GridPlugin);

export default {
  name: "SiteDetails",
  props: {
    siteId: Number,
    showReview: Boolean,
    isSiteReviewReadyData: Object,
    comments: Array,
    ownerInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    ...mapGetters({
      loggedUser: "loggedUser",
      mySites: "mySites",
    }),
    emptySiteDetail() {
      return !this.siteId;
    },
  },
  data() {
    return {
      currentSiteDetails: {},
      currentSiteTanks: [],
      toolbarOptions: ["Search"],
      pageSettings: { pageSize: 15 },
    };
  },
  watch: {
    siteId(siteId) {
      if (siteId) {
        this.currentSiteDetails = this.mySites.find((x) => x.site_Id === siteId);
        this.currentSiteTanks = this.currentSiteDetails.tanks;
        if (this.$refs?.siteComments) this.setCommentBoxValue(siteId);
      }
    },
  },
  methods: {
    goToReview() {
      document.getElementById("collapsible_tab").ej2_instances[0].select(3);
    },
    created() {
      // Added clear button and its functionalities to Searchbar

      if (this.$refs.refTankInfo) {
        const refTankInfoSearchEle = document.getElementById(
          `${this.$refs.refTankInfo.$el.id}_searchbar`,
        );
        if (refTankInfoSearchEle) {
          refTankInfoSearchEle.addEventListener("keyup", (e) => {
            this.clearSearchEventListener(e, this.$refs.refTankInfo.$el.id);
          });
        }
      }
    },
    clearSearchEventListener(e, gridId) {
      const searchBtnEle = document.getElementById(`${gridId}_searchbutton`);
      const clearBtnEle = searchBtnEle.cloneNode(true);
      clearBtnEle.id = `${gridId}_clearbutton`;
      clearBtnEle.classList.remove("e-search-icon");
      clearBtnEle.classList.add("e-clear-icon");

      clearBtnEle.addEventListener("click", () => {
        e.target.value = "";
        document.getElementById(`${gridId}_clearbutton`).remove();
      });

      if (e.target.value && searchBtnEle.parentNode.childElementCount === 2) {
        searchBtnEle.parentNode.insertBefore(clearBtnEle, searchBtnEle.parentNode.children[1]);
      } else if (!e.target.value || e.target.value === "") {
        document.getElementById(`${gridId}_clearbutton`).remove();
      }
    },
    cmdTankDetailsClick(args) {
      if (args.commandColumn.type === "View") {
        if (args.rowData.TankId === null) {
          // ---
        } else {
          this.$router.push(`tanks/${args.rowData.TankId}`);
        }
      }
    },
    onCommentsBoxCreation() {
      this.setCommentBoxValue(this.siteId);
    },
    setCommentBoxValue(siteId) {
      const val = this.comments?.find((x) => x.siteId === siteId)?.comments ?? "";
      this.$refs.siteComments.ej2Instances.value = val;
      this.$parent.changedComments = val;
    },
    onBackButtonClick() {
      const tabObj = document.getElementById("collapsible_tab");
      tabObj.ej2_instances[0].select(0);
    },
    onInputChange(e) {
      this.$parent.checkIfCommentsChange(e.value, this.siteId);
    },
    onExportToExcel() {
      const accessToken = tokenStorage.getAccessToken();
      const userid = this.$store.getters.loggedUser ? this.$store.getters.loggedUser.id : "";
      const { ownerId } = this.ownerInfo;
      const { ownerContactId } = this.ownerInfo;
      const { ownerEmail } = this.ownerInfo;
      const baseTMSUrl = appConfig.tmsApiRootUrl;
      const newURL = `${baseTMSUrl}/eServicesSite/excel_detail?securitytoken=${accessToken}&userid=${userid}&siteid=${this.siteId}&emailAddress=${ownerEmail}&ownerId=${ownerId}&ownerContactId=${ownerContactId}`;
      window.location.href = newURL;
    },
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search],
  },
};
</script>

<style>
@import "../../../assets/styles/eservices-base.css";
.button_section {
  float: right;
  /* flex-flow: row wrap; */
  align-items: center;
}
.site-details-title-color {
  color: #0f4b90;
}
.grid-container-site-details {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;
  column-gap: 5%;
}
.grid-container-location-details {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;
  column-gap: 5%;
}
fieldset {
  border: 1px solid lightgray;
}

.grid-template-col-6 {
  grid-template-columns: repeat(6, 1fr);
}
</style>
